import { useStore } from "@nanostores/preact";
import { useEffect } from "preact/hooks";
import { toggleHotbar, toggleMessage } from "../state/hotbar";
import { $hotbar, $settingsLoaded, inHotbar } from "../state/settings";
import { $historyCode, $myAssets, $panel, $policyCode, $transferCode, toast } from "../state/stores";
import { Panel } from "./Panel";
import { $touchMode } from "../state/touch";
import { refreshMyAssets } from "../state/myAssets";

export function InventoryPanel() {
  const assets = useStore($myAssets);
  const hotbar = useStore($hotbar);
  const loaded = useStore($settingsLoaded);
  const touch = useStore($touchMode);
  useEffect(() => { void refreshMyAssets().catch(() => {}); }, []);

  return (
    <Panel title="我的資產" onClose={() => $panel.set(null)}>
      {assets.length === 0 && <p class="hint">{touch ? "還沒有資產。點 ≡ → 上傳 來新增。" : "還沒有資產。按 Esc → 上傳 來新增。"}</p>}
      <table>
        <tbody>
          {assets.map((a) => (
            <tr key={a.code}>
              <td>{a.name}<br /><code>{a.code}</code></td>
              <td>{a.tri_count} 三角形<br />{a.status === "ready" ? "可用" : a.status} · {a.visibility === "public" ? "公開" : a.visibility === "shared" ? "分享" : "私有"}</td>
              <td>
                <button class={inHotbar(hotbar, a.code) ? "secondary" : ""} disabled={a.status !== "ready" || !loaded}
                  onClick={() => toast(toggleMessage(toggleHotbar(a.code, a.name), a.name))}>
                  {inHotbar(hotbar, a.code) ? "移出快捷列" : "加入快捷列"}
                </button>
                <button class="secondary" onClick={() => { $policyCode.set(a.code); $panel.set("policy"); }}>政策</button>
                <button class="secondary" onClick={() => { $historyCode.set(a.code); $panel.set("history"); }}>歷史</button>
                <button class="secondary" onClick={() => { $transferCode.set(a.code); $panel.set("transfer"); }}>轉讓</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
}
